import React from 'react';
import i18n from '../../../../i18n';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.palette.fixedSuccess.accent,
        borderWidth: 2,
        borderColor: theme.palette.fixedSuccess.main,
        borderStyle: 'solid',
        borderRadius: theme.spacing(1.25),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        textAlign: 'left',
        maxWidth: 343,
        margin: 'auto',
    },
    title: {
        display: 'block',
    },
}));

export const WelcomePopup = () => {
    const { t } = i18n.useTranslation();
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Text className={classes.title} typography={TextTypography.PARA_ACCENT}>
                {t('onboarding:emptyCatalog.welcomeTitle')}
            </Text>
            <Text typography={TextTypography.PARA}>{t('onboarding:emptyCatalog.welcomeText')}</Text>
        </div>
    );
};
